import { DateUtils } from 'react-day-picker';
import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import dateFnsParse from 'date-fns/parse';
import dateFnsFormat from 'date-fns/format';
import dateFnsFormatISO from 'date-fns/formatISO';
import { weekStartLocale, weekDaysLong, weekDaysShort, monthsLong } from './localeUtils';

// eslint-disable-next-line @typescript-eslint/unbound-method
var _isDate = DateUtils.isDate;
function isDate(date) {
  return date !== undefined && _isDate(date);
}
function parseDate(value, format, _locale) {
  if (value === undefined) {
    return undefined;
  }
  var parsed = dateFnsParse(value, format, new Date());
  if (isDate(parsed)) {
    return parsed;
  }
  return undefined;
}
function formatDate(date, format, _locale) {
  var result = dateFnsFormat(date, format);
  return result;
}
function isSameYearAndMonth(date1, date2) {
  return isDate(date1) && isDate(date2) && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}
function formatISODate(date) {
  return dateFnsFormatISO(date, {
    representation: 'date'
  });
}
export { isDate, addDays, addMonths, parseDate, formatDate, isSameYearAndMonth, formatISODate, weekStartLocale as getFirstDayOfWeek, weekDaysLong as getWeekDaysLong, weekDaysShort as getWeekDaysShort, monthsLong as getMonthsLong };